const messages = {
    recurringPayment: 'Recurring payment',
    recurringPaymentDescription:
        'Configure a recurring payment cadence for this provider. Both fields must be set together or left empty.',
    paymentFrequency: 'Payment frequency',
    defaultPaymentAmount: 'Default payment amount',
    paymentFrequencyNone: 'None / Manual',
    paymentFrequencyWeekly: 'Weekly',
    paymentFrequencyBiWeekly: 'Bi-Weekly',
    paymentFrequencyMonthly: 'Monthly',
    recurringPaymentBothRequired:
        'Payment frequency and default amount must be set together, or both left empty.',
    recurringPaymentAmountGreaterThanZero:
        'Default payment amount must be greater than zero when set.',
    openDraftCollisionTitle: 'An open payment period already exists',
    openDraftCollisionDescription:
        'A payment period for {payDate} is already open. Resume the existing period or cancel to choose another action.',
    openDraft: 'Open Draft',
    goToReview: 'Go to Review',
    draftCount: 'Draft',
    reviewCount: 'Review',
    printedCount: 'Printed',
    // Invoices tab
    uploadInvoice: 'Upload invoice',
    noInvoices: 'No invoices yet',
    invoiceDeletedSuccessfully: 'Invoice deleted successfully',
    errorLoadingInvoices: 'Error loading invoices',
    youWantToRemoveInvoice: 'Delete invoice',
    invoiceDelete: 'Are you sure you want to delete this invoice? This action cannot be undone.',
    errorDownloadingInvoice: 'Error downloading invoice',
    fileName: 'File name',
    invoiceDate: 'Invoice date',
    uploadedOn: 'Uploaded on',
    unauthorizedViewInvoices: "You don't have authorization to view invoices",
    unauthorizedViewPayments: "You don't have authorization to view payments",
    // External providers list
    errorLoadingProviders: 'Error loading providers',
};

export default messages;
